export default "__VITE_ASSET__CCrlsHNB__"